export const LOCATION_PAGINATION_GROUP_ID_PREFIX = "locations_by_property_";
export const ISSUE_PAGINATION_GROUP_ID_PREFIX = "issues_by_location_";